"use client";

import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { colors } from "./theme";

interface SectionCardProps {
  title: string;
  icon: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  icon,
  action,
  children
}) => (
  <Card
    elevation={0}
    sx={{
      height: "100%",
      border: `1px solid ${colors.neutral2}20`,
      borderRadius: "8px",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
      }
    }}
  >
    <CardContent sx={{ p: 0 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1.5}
        borderBottom={`1px solid ${colors.neutral2}20`}
      >
        <Box display="flex" alignItems="center">
          {React.cloneElement(icon as React.ReactElement, {
            sx: { color: colors.accent1, mr: 1 }
          })}
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: colors.primary,
              fontWeight: 600,
              fontSize: "1rem"
            }}
          >
            {title}
          </Typography>
        </Box>
        {action && <Box>{action}</Box>}
      </Box>
      <Box p={2}>{children}</Box>
    </CardContent>
  </Card>
);